import React from "react";

const WorkPlanContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            Work Plan
          </h1>
          <p className="text-[15px] font-medium">
            <h1 className="text-[17px] font-semibold text-amber-700 pb-2">
              Statement of problem
            </h1>
            One-sixth of world population lives in India. To provide access to
            education to such a huge human resource is a stupendous task. A
            substantial portion of the population is not able to access
            secondary and senior secondary education owing to social and
            economic reasons.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Resolution to the problem
            </h1>
            To provide secondary education to every citizen of the country and
            make job-oriented, The Council for Secondary and Senior Secondary
            Education (CSSE) has come out with an ambitious proposal at national
            level, which is as follows:
            <div className="flex flex-row justify-center py-2">
              <div className="flex flex-row w-3/4 justify-between">
                <div className="flex flex-col gap-1">
                  <h1 className="text-sm">1. Project</h1>
                  <h1 className="text-sm">2. Implementing Agency</h1>
                  <h1 className="text-sm">3. Project Category</h1>
                </div>
                <div className="flex flex-col gap-1">
                  <h1 className="text-sm">- Open Schooling in India</h1>
                  <h1 className="text-sm">
                    - Council for Secondary and Senior Secondary Education
                  </h1>
                  <h1 className="text-sm">
                    - Secondary education and Vocational training
                  </h1>
                </div>
              </div>
            </div>
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Aim of the Project
            </h1>
            To bring the socially and economically deprived sections of the
            society into the main stream education with provision to give
            equivalence between them and thereby accelerate and enhance the
            percentage of literacy in the country.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Objective
            </h1>
            To provide secondary and senior secondary education to those
            belonging to disadvantaged groups (e.g. the Scheduled Castes, the
            Scheduled Tribes, Socially and Educationally backward classes and
            other groups having disadvantage owing to social, cultural,
            economic, geographical, linguistic, gender or such other factor as
            may be specified by the appropriate Government, notification) and
            the people belonging to weaker section are not able to get routine,
            secondary and senior secondary education.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Beneficiaries
            </h1>
            Disadvantaged groups (e.g. the Scheduled Castes, the Scheduled
            Tribes, Socially and Educationally disadvantaged classes and other
            socially, culturally, economically, geographically sections of the
            society, or such other factors as may be specified/ notified by the
            appropriate Government) and people belonging to weaker sections who
            are not able to get secondary and senior secondary education in the
            normal course of life.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Status of CSSE
            </h1>
            CSSE is a registered society under Societies Registration Act
            No.XXI, 1860 Govt. of NCT of Delhi to work in school education
            sector at national level in accordance with the specified rules and
            regulations.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Verification of the certificates and their equivalences
            </h1>
            The Examination Wing of the Council would verify and certify the
            genuineness of the certificates issued by the Council. For this
            purpose, it has already been resolved by the CSSE to submit an
            application to the Council of Boards of School Education in India
            (COBSE) seeking their membership.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Curriculum{" "}
            </h1>
            It is resolved to apply to COBSE and other member-boards of COBSE
            for grant of `equivalence of the curriculum developed by the Council
            in line with the NCF 2005 of the NCERT. It is also proposed to
            develop vocational education and training/technical curriculum by
            CSSE.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Admission and registration
            </h1>
            Students from different parts of the country can seek admission to
            various courses conducted by the CSSE without any caste, creed or
            social barriers.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Setting up of Academic centres
            </h1>
            Towards this end, it is proposed to affiliate the on-going
            educational study centres to develop a parallel non-conventional
            system of education so that it does not impact the existing
            resources of the country.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Scheme of Examinations
            </h1>
            The CSSE proposes to conduct secondary and senior secondary
            examination twice a year. In addition, it is also proposed to offer
            offline, online on-demand examination in case the number of students
            at any centre is 50 or more.
            <h1 className="text-[17px] font-semibold text-amber-700 py-2">
              Declaration of results and issue of certificates and mark-sheet
            </h1>
            Immediately on completion of board examination but not exceeding one
            month, results would be declared and certificates/ mark-sheets would
            be issued through the Academic Centres. The following certificates
            would be issued by the CSSE:
            <ul className="list-disc px-10 flex flex-col gap-1 py-1">
              <li>Mark-sheet and examination certificate</li>
              <li>Character certificate</li>
              <li>Migration/transfer certificate</li>
            </ul>
            To operationalize the above scheme, it is proposed to set up the
            following departments/ committees
            <ul className="list-disc px-10 flex flex-col gap-1 py-1">
              <li>General Body Management Committee</li>
              <li>Department of Academics</li>
              <li>Recognition/ Affiliation department</li>
              <li>Recognition/ Affiliation department</li>
              <li>Department of Public Relations & Welfare</li>
              <li>Department of Finance</li>
              <li>Information & Technology Department</li>
            </ul>
          </p>
        </div>
      </div>
    </>
  );
};

export default WorkPlanContainer;
